import React, { useEffect, useRef, useState } from 'react';
import { FilterContainer, FilterHeader, PageTitle } from 'resources/styles/TableStyle';

import styled, { createGlobalStyle } from 'styled-components';
import { Button as SaladButton, Row } from 'saladsoft-primitive';
import { TextField } from '@mui/material';
import { ReservationPeriodFilterType } from 'types/CommonTypes';

import { observer } from 'mobx-react-lite';
import { useStoreWrapper } from 'stores/StoreHelper';
import { getUrlParam } from 'libs/helper/utils';
import { setUrlParams, deleteUrlParams } from 'libs/helper/paramsUtil';
import Button from 'components/input/NewButton';
import SearchBox from 'components/input/SearchBox';
import TableHeader from '../tables/TableHeader';
const GlobalInputStyle = createGlobalStyle`
  .MuiOutlinedInput-input {
    padding: 10px !important;
  }
`;

const VoucherCategoryFilter = observer(({
  onClickAdd,
}: {
  onClickAdd: () => void;
}) => {
  const items = [
    { value: 'RESERVATION', label: '예약일기준' },
    { value: 'ARRIVAL', label: '입실일기준' },
    { value: 'DEPARTURE', label: '퇴실일기준' },
    { value: 'CANCELED', label: '취소일기준  ' },
    { value: 'CONFIRMATION', label: '확정일기준  ' },
  ];

  const keyword = useRef<string>('');
  const inputRef = useRef<any>(null);

  const [periodType, setPeriodType] = useState<ReservationPeriodFilterType['periodType']>('ALL');
  const [status, setStatus] = useState<ReservationPeriodFilterType['status']>('ALL');
  const [isSearched, setIsSearched] = useState<boolean>(false);

  const [searchKeyword, setSearchKeyword] = useState<string>('');
  const [itemIndex, setItemIndex] = useState<number>();


  const handleChangeType = (value: string) => {
    setUrlParams({
      periodType: value,
    });
  };

  const [innerSelectedDateRange, setInnerSelectedDateRange] = useState<
    [string | null, string | null]
  >([null, null]);

  const { reservationFilterStore } = useStoreWrapper();


  const handleChangePeriod = (dateRange: [string | null, string | null]) => {
    if (dateRange[0] && dateRange[1]) {
      setUrlParams({
        startDate: dateRange[0],
        endDate: dateRange[1],
      });

      setInnerSelectedDateRange(dateRange);
    }
  };


  useEffect(() => {
    const from = getUrlParam('startDate');
    const to = getUrlParam('endDate');
    const search = getUrlParam('search');
    if (search) {
      setIsSearched(true);
    } else {
      setIsSearched(false);
    }
    setInnerSelectedDateRange([from, to]);
    setSearchKeyword(search || '');
  }, []);


  /** 만약 특정 SaladToggleButton을 사용할 경우, 파라미터를 검사하여 해당 값을 기본값으로 전달한다. */
  useEffect(() => {
    const periodType = getUrlParam('periodType');
    setItemIndex(periodType ? items.findIndex(item => item.value === periodType) : 0);
  }, [periodType]);

  return (
    <div>
      <GlobalInputStyle />
      <Row justifyContent="space-between" width="100%" marginTop="10px">
        <PageTitle >바우처 그룹 관리</PageTitle>
        <FilterContainer>

          <SearchBox
            paramKey="search"
            placeholder="카테고리명"
          />

        </FilterContainer>
        <div style={{ width: 150 }}>
          <Button onClick={() => { onClickAdd() }}>카테고리 추가</Button>
        </div>
      </Row>
    </div>
  );
});

export default VoucherCategoryFilter;
